module.exports = __webpack_public_path__ + "img/anxious2.a4cf6358.png";